import React, {useState, useEffect} from 'react';
import {NavLink, Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    Box,
    Flex,
    IconButton,
    useBreakpointValue,
    useDisclosure,
    Image,
    Link as LinkChakra
} from '@chakra-ui/react';
import {HamburgerIcon, CloseIcon} from '@chakra-ui/icons';
import data from '../../lang/arsskyrsla-data.json';
import MobileMenuDropDown from '../dropDowns/MobileMenuDropDown';

const Navbar = ({menuItems, onHomepage}) => {
    Navbar.propTypes = {
        menuItems: PropTypes.array.isRequired,
        onHomepage: PropTypes.bool.isRequired,
    };

    const logoWhite = data.siminnWhiteLogo;
    const logoBlue = data.siminnLogo;
    const {isOpen, onToggle} = useDisclosure();
    const mobileOpened = isOpen ? "#1A1A42" : "transparent";
    const closeIconWhite = isOpen ? "#FFFFFF" : "#12232C";
    const mobileBackground = !isOpen ? "#FFFFFF" : "#1A1A42";
    const iconWhite = isOpen ? logoWhite : logoBlue;

    const [lastScrollY, setLastScrollY] = useState(0);
    const [navbarStyle, setNavbarStyle] = useState({
        transform: 'translateY(0)',
        opacity: 1,
        visibility: 'visible'
    });
    const mobileNav = {
        backgroundColor: onHomepage ? "#1A1A42" : mobileBackground
    };
    const mobileOptionsMenu = ["Ársskýrsla 2024"];
    const isMobile = useBreakpointValue({base: true, md: false});

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0 && window.scrollY > lastScrollY) {
                setNavbarStyle({
                    transform: 'translateY(-100%)',
                    opacity: 0,
                    visibility: 'hidden',
                });
            } else if (window.scrollY <= 0) {
                setNavbarStyle({
                    backgroundColor: "transparent",
                });
            } else {
                setNavbarStyle({
                    transform: 'translateY(0)',
                    opacity: 1,
                    visibility: 'visible',
                    backgroundColor: onHomepage ? "#1A1A42" : "#FFFFFF"
                });
            }
            setLastScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY, onHomepage, isMobile]);


    return (
        <Box
            position="fixed"
            top="0"
            width="100%"
            zIndex="100"
            bgColor={mobileOpened}
            color={onHomepage ? "#FFFFFF" : "#12232C"}
            transition={isMobile ? "none" : "all 0.5s ease-in-out"}
            style={!isMobile ? {...navbarStyle} : mobileNav}
            justifyContent="space-between"
            p={4}
            className="grid-container"
        >
            <div className="navbar-desktop-img">
                <LinkChakra href="/">
                    <Image src={onHomepage ? logoWhite : iconWhite} boxSize="50px" mr={4}/>
                </LinkChakra>
            </div>

            {!isMobile && (
                <div className="navbar-desktop-menuitems">
                    <Flex gap="24px">
                        {menuItems.map(item => (
                            <NavLink key={item.label} to={`/${item.url}`} cursor="pointer" activeClassName="active">
                                {item.label}
                            </NavLink>
                        ))}
                    </Flex>
                </div>
            )}

            {isMobile && (
                <IconButton
                    icon={
                        isOpen ? (
                            <CloseIcon w="24px" h="24px"/>
                        ) : (
                            <HamburgerIcon w="24px" h="24px"/>
                        )
                    }
                    onClick={onToggle}
                    variant="ghost"
                    _hover={{bg: 'transparent'}}
                    color={onHomepage ? "#FFFFFF" : closeIconWhite}
                    backgroundColor={onHomepage ? "#1A1A42" : mobileOpened}
                    zIndex={9999}
                    className="navbar-desktop-menuitems"
                />
            )}
            {/* Mobile Menu */}
            {isOpen && isMobile && (
                <Box
                    pos="fixed"
                    top="64px"
                    left="0"
                    right="0"
                    bottom="0"
                    bgColor="#1A1A42"
                    color="white"
                    zIndex="overlay"
                    pt="50px"
                    pl="16px"
                >
                    <Flex
                        direction="column"
                        justifyContent="center"
                        alignItems="start"
                        gap={4}
                    >
                        {menuItems.map(item => (
                            <Link
                                key={item.label}
                                to={`/${item.url}`}
                                cursor="pointer"
                                className="menuRef"
                                onClick={onToggle}
                            >
                                {item.label}
                            </Link>
                        ))}
                    </Flex>
                    <MobileMenuDropDown options={mobileOptionsMenu}/>
                </Box>
            )}
        </Box>
    );
};

export default Navbar;